var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 76,
    viewBox: "0 0 53 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.744 36.0816V40.152H48.4768C48.016 57.5856 38.3392 71.7168 26.512 71.7168C14.3008 71.7168 4.47042 56.8944 4.47042 38.232C4.47042 19.6464 14.3008 4.7472 26.512 4.7472C32.7328 4.7472 38.5696 8.7408 43.2544 16.5744L46.7104 14.424C41.4112 5.592 34.1152 0.676804 26.512 0.676804C12.1504 0.676804 0.400024 17.7264 0.400024 38.232C0.400024 58.8144 12.1504 75.864 26.512 75.864C40.7968 75.864 52.5472 58.7376 52.5472 38.1552V36.0816H25.744Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperG);
export default __webpack_public_path__ + "static/media/UPPER_G.5ea007e64fc2eadeb649e7be78968b43.svg";
export { ForwardRef as ReactComponent };